import { API_URL } from '@/consts/urls';
import { getContext } from '@/context';

export interface UserTier {
  id: string;
}

/**
 * Current user's subscription tier. Returns null on network failure so
 * callers can decide UX (typically: treat as free / non-pro).
 */
const getUserTier = async (): Promise<UserTier | null> => {
  try {
    const queryParams = new URLSearchParams({ invalidate_cache: '0' });
    const response = await getContext().utils.api.fetch(
      `${API_URL}/guard/users/tier?${queryParams}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }
    );
    if (!response.ok) return null;
    const data = await response.json();
    const tierInfo = data.response || data.data || data;
    if (!tierInfo?.id) return null;
    return { id: tierInfo.id };
  } catch {
    return null;
  }
};

export default getUserTier;
